<template>
  <slot />
</template>

<script setup lang="ts">
import { serializeJsonLd } from "@/shared/utils/jsonLdSerialize";

interface JsonLDModelOptions {
  type?: string;
  name?: string;
  jobTitle?: string;
  url?: string;
  image?: string;
}

const props = defineProps<{ jsonOptions: JsonLDModelOptions }>();

useHead(() => ({
  script: [
    {
      type: "application/ld+json",
      innerHTML: serializeJsonLd({
        "@context": "https://schema.org",
        "@type": props.jsonOptions.type ?? "",
        name: props.jsonOptions.name ?? "",
        jobTitle: props.jsonOptions.jobTitle ?? "",
        url: props.jsonOptions.url ?? "",
        image: props.jsonOptions.image ?? "",
      }),
    },
  ],
}));
</script>

<style scoped></style>
